import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const WarningIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" strokeWidth="1.5" {...props}>
            <path
                d="M8.64974 3.21635L1.96163 14.9997C1.82374 15.2517 1.75078 15.5374 1.75001 15.8285C1.74923 16.1195 1.82068 16.4056 1.95723 16.6585C2.09379 16.9113 2.29069 17.122 2.52835 17.2696C2.76602 17.4171 3.03615 17.4965 3.31189 17.4997H16.6881C16.9638 17.4965 17.234 17.4171 17.4716 17.2696C17.7093 17.122 17.9062 16.9113 18.0428 16.6585C18.1793 16.4056 18.2508 16.1195 18.25 15.8285C18.2492 15.5374 18.1763 15.2517 18.0384 14.9997L11.3503 3.21635C11.2095 2.97144 11.0113 2.76895 10.7748 2.62842C10.5383 2.48789 10.2714 2.41406 10 2.41406C9.72858 2.41406 9.46174 2.48789 9.22523 2.62842C8.98871 2.76895 8.79051 2.97144 8.64974 3.21635V3.21635Z"
                stroke="currentColor"
                strokeWidth="inherit"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M10 7.5V10.8333"
                stroke="currentColor"
                strokeWidth="inherit"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10 14.167H10.0083"
                stroke="currentColor"
                strokeWidth="inherit"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
